export const pagesConfig = {
    healthCredentials: {},
    users: {},
};
